import * as React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import { AdminMedicineModel } from "../../models/medicine";
import ManufacturerService from '../../services/manufacturerService';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  getContent: any
}

interface IState {
}

class MedicineTabOverview extends React.Component<IProps, IState> {

  manufacturerService = new ManufacturerService();

  constructor(props: IProps) {
    super(props);

    this.state = {
    };
  }

  public render() {

    const { medicine } = this.props;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-12">
          <label>Summary:</label>
          <Editor
            style={{ width: '100%', height: '120px' }}
            onTextChange={(e) => { this.props.handleChange('overviewSummary', e.htmlValue) }}
            value={this.props.getContent('overviewSummary')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>About Medicine:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewAboutMedicine', e.htmlValue)}
            value={this.props.getContent('overviewAboutMedicine')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>Before Intake:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewBeforeIntake', e.htmlValue)}
            value={this.props.getContent('overviewBeforeIntake')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>Dosage:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewDosage', e.htmlValue)}
            value={this.props.getContent('overviewDosage')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>Side Effects:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewSideEffects', e.htmlValue)}
            value={this.props.getContent('overviewSideEffects')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>Safety Data:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewSafetyData', e.htmlValue)}
            value={this.props.getContent('overviewSafetyData')}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <label>Additional Info:</label>
          <Editor
            style={{ width: '100%', height: '100px' }}
            onTextChange={(e) => this.props.handleChange('overviewAdditionalInfo', e.htmlValue)}
            value={this.props.getContent('overviewAdditionalInfo')}
          />
        </div>
      </div>
    )
  }
}

export default MedicineTabOverview;